import { diff } from "deep-diff";

export function checkObjectsForDifferences(a: any, b: any): boolean {
  const differences = diff(a, b);
  return !!(differences && differences.length > 0);
}
